import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable complexity */
import { fromJS } from 'immutable';
import md5 from 'js-md5';
import moment from 'moment';
import { atou, ISO_8601_MS_RESOLUTION, findContactFromChatUserKey } from 'flow/utils';
import { getClientType } from 'flow/utils/app-utils';
import { findExtension } from 'flow/utils/extension-utils';
import { receiveTopMessage, receiveMessageRead, receiveChatSessionUnread, receiveTopComment, receiveTopAddAdmin, receiveTopRemoveAdmin, receiveTopRemoveMemberFromChat, receiveTopAddMemberToChat, updateReactions } from 'flow/actions/chat-actions';
import { receiveTopPresenceNotification, receiveTopVoiceMessage } from 'flow/actions/extension-actions';
import { receiveTopPbxVoiceMessage } from 'flow/actions/pbx-actions';
import { handleCompanionCallControl, handleCompanionDesignation, handleCompanionLocationStatus, reportKnownCompanionLocationStatus, sweepCompanionMuteState } from 'flow/companion/companion-actions';
import { receiveIsTyping, channelSessionBadgeCount, receiveChannelMessageRead, receiveArchived, receiveUnarchived } from 'flow/actions/channels-actions';
import { onReceivedTopEventPushOfTypeOmniErrand, onReceivedTopEventPushOfTypeAssignedOmniErrand } from 'flow/actions/omnichannel-actions';
import { onTopEventTicketWhatsAppTemplateMessage, onTopEventPushOfTypeTicketAssigneeSet, onTopEventPushOfTypeTicketStateSet, onTopEventPushOfTypeTicketInternalNoteReceived, onTopEventPushOfTypeTicketWhatsAppMessageReceived, onTopEventPushOfTypeTicketSmsReceived, onTopEventPushOfTypeTicketCreatedReceived, onTopEventPushOfTypeTicketMembersChanged, onTopEventTicketAwaitingActivitySet, onTopEventTicketVisibilitySet, onTopEventTicketMessageStatusSet, onTopEventTicketSubjectSet, onTopEventPushOfTypeTicketWhatsAppUnsupportedMessage, onTopEventPushTypeTicketsBadgeCount, onTopEventTicketTranscriptionProgress, onTopEventPushTypeTicketEmailMessageReceived } from 'flow/actions/tickets-action';
import { receiveSyncStart, receiveSyncStop, receiveExtension, receiveActiveProfile, receiveNewChannel, receiveMexIn, receiveMexOut, receiveNewState, receiveHangup, receiveGoAway, receiveQueueAgentActivity, receiveQueueJoinEvent, receiveQueueLeaveEvent, receiveNumberInfo, receiveLink, receiveQueueCallInfo, receiveBagVariable, receiveCoMonitoredStart, receiveCoMonitoredEnd, receiveQueueMembers, receiveAttendedTransferCancelled, receiveExternalChannel, receiveMergedIntoConference, receiveUpdateCallerID, onTopEventCallRecordingTranscriptionProgress } from 'flow/actions/top-actions';
import { updateMissedCallState, spawnLastAgentNotification, comeBackAPICallbacks } from 'flow/actions/app-actions';
import { addTopLogEntry } from 'flow/utils/browser-utils';
import { recieveMeetingMemberCount, clearMeetingMemberCountsAction } from 'flow/actions/meeting-actions';
import appConfig from 'app-config';
import isElectron from 'is-electron';
import { getOwnExtensionKey } from 'flow/selectors/selectors';
import { handleVideo2IncomingCall, handleVideo2CallDeclined, handleVideo2CallAccepted, handleVideo2CallCanceled, handleVideo2CallHandledOnOtherDevice } from 'flow/actions/video2-actions';
import { onTopEventCallRecordActionAdded, onTopEventCallRecordActionRemoved } from 'flow/actions/PbxActions';
import { roomTypes } from 'flow/utils/message-utils-TW';
var PING_INTERVAL_MS = 10000;
var PING_TIMEOUT_MS = 30 * 1000;

// How long a probe (on wake-up or network change) waits for anything from Top before giving the
// connection up. Short, because the caller has a reason to doubt the socket.
var PROBE_TIMEOUT_MS = 5000;

// How long a new socket may take to open. A connect that hangs on a network that went away (for
// example across a sleep) would otherwise hold off every reconnect until the browser gives up.
var CONNECT_TIMEOUT_MS = 15000;
var CLOSE_EVENT_NORMAL_CODE = 1000;
var queueMemberEventsByQueue = new Map();
var syncMessages = [];
var socket;
// The live connection's own handles, so that only the socket that is current can act on the
// module state. See createSocket.
var currentConnection = null;
var requestId = 0;
var pendingRequests = new Map();

// Exported for tests only
export var _sendAsyncRequest = function _sendAsyncRequest(request) {
  return new Promise(function (resolve, reject) {
    request.ActionID = requestId++;
    var timeoutId = setTimeout(function () {
      pendingRequests["delete"](request.ActionID);
      reject({
        reason: 'TIMED_OUT',
        request: request
      });
    }, 5000);
    pendingRequests.set(request.ActionID, {
      resolve: resolve,
      reject: reject,
      timeoutId: timeoutId,
      request: request
    });
    _sendRequest(request);
  });
};

// Exported for tests only
export var _sendRequest = function _sendRequest(request) {
  if (!socket || socket.readyState !== WebSocket.OPEN) {
    addTopLogEntry('Tried to send request to top but no connection, request: ', request);
    return;
  }
  socket.send(JSON.stringify(request));
};
var handleOk = function handleOk(response) {
  var actionId = Number(response.ActionID);
  if (isNaN(actionId) || !pendingRequests.has(actionId)) {
    return;
  }
  var pendingRequest = pendingRequests.get(actionId);
  pendingRequests["delete"](actionId);
  clearTimeout(pendingRequest.timeoutId);
  pendingRequest.resolve(response);
};
var handleError = function handleError(response) {
  var actionId = Number(response.ActionID);
  if (isNaN(actionId) || !pendingRequests.has(actionId)) {
    return;
  }
  var pendingRequest = pendingRequests.get(actionId);
  pendingRequests["delete"](actionId);
  clearTimeout(pendingRequest.timeoutId);
  pendingRequest.reject({
    reason: 'ERROR',
    response: response
  });
};
export var mergeIntoConference = function mergeIntoConference(uniqueIdToKeep, uniqueIdsToMerge) {
  var request = {
    Action: 'MergeIntoConference',
    CallToKeep: uniqueIdToKeep,
    AdditionalCalls: uniqueIdsToMerge
  };
  return _sendAsyncRequest(request);
};
export var hangupCall = function hangupCall(uniqueId) {
  var request = {
    Action: 'Hangup',
    UniqueID: uniqueId
  };
  _sendRequest(request);
};

/**
 * Whether there is a usable connection to TOP right now.
 *
 * Exposed so a caller with a second way to reach its destination can pick it instead of sending
 * into a closed socket - `_sendRequest` drops the frame silently, and `_sendAsyncRequest` would
 * sit on it until the 5s timeout before anyone found out.
 */
export var isConnected = function isConnected() {
  return !!socket && socket.readyState === WebSocket.OPEN;
};

/**
 * Ask Top whether the connection is still alive, giving it up if nothing comes back shortly.
 * Sending on a dead socket does not fail - the bytes are only buffered - so after a sleep or a
 * network change the only way to find out is to wait for an answer.
 */
export var probeTopConnection = function probeTopConnection() {
  if (currentConnection) {
    currentConnection.probe();
  }
};

/**
 * Close the Top connection, or the one still being opened, without reconnecting.
 */
export var closeTopConnection = function closeTopConnection(reason) {
  if (currentConnection) {
    currentConnection.abandon(reason);
  }
};

/**
 * Relay a call-control command to this user's companion (the desktop app that owns the media).
 *
 * Sent to TOP rather than to Home, which used to relay it back into TOP as a push: the CTI already
 * holds this socket, so the round-trip bought nothing. TOP resolves the call's legs from the
 * channel state it already has in memory, so - unlike Home - it needs neither a database lookup
 * nor a callIds array from us.
 *
 * `deviceId` says which of the user's desktop installs the command is for, and has to travel: TOP
 * hands the command to every FLOW_DESKTOP connection on the anumber and fans out to the other
 * nodes, so nothing about delivery narrows it to one machine. The receiving side refuses anything
 * not addressed to it. Home stamps the account's designated device rather than trusting the body;
 * TOP cannot, that being the database lookup this path exists to avoid, so it carries ours through
 * (see Telavox/top#668).
 *
 * @returns {Promise} resolves on `Response: OK`, rejects with `{reason: 'ERROR'}` when TOP refuses
 *          the command and `{reason: 'TIMED_OUT'}` when no answer arrives within 5s
 */
export var companionCommand = function companionCommand(_ref) {
  var command = _ref.command,
    callId = _ref.callId,
    number = _ref.number,
    digits = _ref.digits,
    nonce = _ref.nonce,
    deviceId = _ref.deviceId;
  var request = {
    Action: 'CompanionCommand',
    Command: command,
    Nonce: nonce
  };
  if (callId) {
    request.CallID = callId;
  }
  if (number) {
    request.Number = number;
  }
  if (digits) {
    request.Digits = digits;
  }
  if (deviceId) {
    request.DeviceID = deviceId;
  }
  return _sendAsyncRequest(request);
};

/**
 * Report this client's microphone state to TOP, which records it on the named channel as the
 * `telavox.companion.locally-muted` bag variable and relays it to the user's other clients.
 *
 * Fire-and-forget: advisory display state, and the next mute corrects a lost frame.
 *
 * @param {boolean} muted
 * @param {string} [channel] this call's channel name. Optional - with one call up TOP uses it
 *     anyway; with two and no name it drops the report.
 */
export var setCompanionMute = function setCompanionMute(muted, channel) {
  var request = {
    Action: 'SetCompanionMute',
    Muted: muted ? 'true' : 'false'
  };
  if (channel) {
    request.Channel = channel;
  }
  _sendRequest(request);
};
export var pickupQueueCall = function pickupQueueCall(queue, queueId, pickerNumber) {
  var request = {
    Action: 'PickupQueue',
    Queue: queue,
    QueueID: queueId,
    Number: pickerNumber,
    AutoAnswer: true
  };
  _sendRequest(request);
};
export var pickupCall = function pickupCall(uniqueId, pickerNumber) {
  var request = {
    Action: 'CallPickup',
    UniqueID: uniqueId,
    Extension: pickerNumber,
    Barge: false,
    AutoAnswer: true
  };
  _sendRequest(request);
};
export var pushAgentCallback = function pushAgentCallback(actions, tpn) {
  if (!tpn.silent) {
    var description = tpn.data.description;
    var pushData = {
      description: description,
      sent: moment().format('HH:mm')
    };
    return actions.push(spawnLastAgentNotification(pushData));
  }
  return undefined;
};

//Since messages will be received decoded from top we want to hide them to keep the privacy intact
var enchipherMessage = function enchipherMessage(app, message) {
  var pushedMessage = message ? message : '';
  if (!app.get('temporaryPasswordState')) {
    return pushedMessage;
  } else {
    return 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';
  }
};
var extensionKeyForChatUser = function extensionKeyForChatUser(getState, chatUserKey) {
  return findExtension(getState, function (e) {
    return e.get('chatUserKey') === chatUserKey;
  }).get('key');
};

/**
 * The quoted part of a reply, in the shape a message row renders it: the row
 * shows the block only when quotedMessageKey is set, then reads content,
 * sender.extensionKey and sent. The push carries all of that, just under
 * different names, so mapping it here means a reply arriving while the chat is
 * open renders as a reply immediately instead of as plain text until the
 * refetch lands.
 */
export var _quotedMessageFromPush = function _quotedMessageFromPush(getState, data) {
  return data.quotedMessageKey ? {
    quotedMessageKey: data.quotedMessageKey,
    content: data.quotedMessageContent,
    sent: data.quotedMessageSent,
    sender: {
      extensionKey: extensionKeyForChatUser(getState, data.quotedMessageSenderKey)
    }
  } : undefined;
};
var pushToActions = function pushToActions(getState, tpn) {
  var actions = [];
  var _getState = getState(),
    app = _getState.app,
    chats = _getState.chats;
  if (tpn.type === 'chat_newmessage') {
    var me = app.getIn(['extension', 'chatUserKey']);
    var _tpn$data = tpn.data,
      sessionKey = _tpn$data.sessionKey,
      senderKey = _tpn$data.senderKey,
      messageKey = _tpn$data.messageKey,
      message = _tpn$data.message,
      title = _tpn$data.title,
      threadMessageKey = _tpn$data.threadMessageKey;
    var contact = findContactFromChatUserKey(getState, sessionKey, senderKey);
    var quotedMessage = _quotedMessageFromPush(getState, tpn.data);
    var chatUserDTO = {
      key: senderKey,
      contact: contact,
      extensionKey: extensionKeyForChatUser(getState, senderKey)
    };
    var messageDTO = fromJS(_objectSpread(_objectSpread({
      key: messageKey,
      // A title means a post. Naming the type here is what lets the
      // message list pick the post card straight away, and keeps an
      // ordinary message in its sender's run instead of starting a new
      // one until the fetched copy supplies the type.
      type: title ? 'post' : 'message',
      from: chatUserDTO,
      message: enchipherMessage(app, message),
      title: title,
      read: me === senderKey,
      sent: moment().format(ISO_8601_MS_RESOLUTION),
      source: 'Top'
    }, quotedMessage ? {
      quotedMessage: quotedMessage
    } : {}), {}, {
      threadMessageKey: threadMessageKey
    }));
    actions.push(receiveTopMessage(sessionKey, messageDTO, tpn.silent));
  } else if (tpn.type === 'last_queue_member') {
    pushAgentCallback(actions, tpn);
  } else if (tpn.type === 'last_channel_member') {
    pushAgentCallback(actions, tpn);
  } else if (tpn.type === 'chat_newcomment') {
    var _tpn$data2 = tpn.data,
      _sessionKey = _tpn$data2.sessionKey,
      _senderKey = _tpn$data2.senderKey,
      _messageKey = _tpn$data2.messageKey,
      commentKey = _tpn$data2.commentKey,
      _message = _tpn$data2.message;
    var _contact = findContactFromChatUserKey(getState, _sessionKey, _senderKey);
    var _chatUserDTO = fromJS({
      key: _senderKey,
      contact: _contact,
      extensionKey: findExtension(getState, function (e) {
        return e.get('chatUserKey') === _senderKey;
      }).get('key')
    });
    var comment = fromJS({
      key: commentKey,
      chatMessageKey: _messageKey,
      from: _chatUserDTO,
      message: enchipherMessage(app, _message),
      sent: moment().format(ISO_8601_MS_RESOLUTION),
      source: 'Top'
    });
    actions.push(receiveTopComment(_sessionKey, comment));
  } else if (tpn.type === 'chat_messageread') {
    var _tpn$data3 = tpn.data,
      _sessionKey2 = _tpn$data3.sessionKey,
      _messageKey2 = _tpn$data3.messageKey,
      channelKey = _tpn$data3.channelKey;
    var session = chats.getIn(['sessions', _sessionKey2]);

    // Missing session in list might be a channel message therefore we don't add them.
    if (session) {
      var _messageDTO = {
        key: _messageKey2,
        read: true
      };
      actions.push(receiveMessageRead(_sessionKey2, _messageDTO));
    } else if (channelKey) {
      var _messageDTO2 = {
        key: _messageKey2,
        read: true
      };
      actions.push(receiveChannelMessageRead(channelKey, _sessionKey2, _messageDTO2));
    }
  } else if (tpn.type === 'chat_messageunread') {
    var data = tpn.data;
    var chatSessionDTO = {
      key: data.sessionKey,
      lastReadMessage: data.messageKey,
      numberOfUnreadMessages: 1
    };
    actions.push(receiveChatSessionUnread(chatSessionDTO));
  } else if (tpn.type === 'reachable') {
    var _data = tpn.data;
    var loggedinKey = getOwnExtensionKey(getState());
    var availableExtensionKey = _data.key;
    var _contact2 = findExtension(getState, function (e) {
      return e.get('key') === availableExtensionKey;
    }).get('contact');

    // Add the contact to the data received from Top. The notification needs a name and an avatar.
    var targetExtensionDTO = fromJS(_objectSpread(_objectSpread({}, _data), {}, {
      contact: _contact2
    }));
    actions.push(receiveTopPresenceNotification(loggedinKey, targetExtensionDTO, tpn.silent));
  } else if (tpn.type === 'dto') {
    var _data2 = tpn.data;
    if (_data2.dtotype === 'VideoSessionDTO') {
      addTopLogEntry('User was contacted by 1-1 video, this function is deprecated and will not be presented');
    } else if (_data2.dtotype === 'IsTypingDTO') {
      var dtodata = atou(_data2.dto);
      var isTypingDTO = JSON.parse(dtodata);
      var _channelKey = isTypingDTO.channel.key;
      var chatSessionKey = isTypingDTO.chatSession.key;
      var extensionKey = _data2.from;
      var typing = isTypingDTO.typing;
      actions.push(receiveIsTyping(_channelKey, chatSessionKey, extensionKey, typing));
    }
  } else if (tpn.type === 'voicemail') {
    var _data3 = tpn.data;
    var _loggedinKey = getOwnExtensionKey(getState());
    var voiceMessageDTO = fromJS({
      uniqueId: _data3.uniqueId,
      number: _data3.lastCallerId,
      voiceMessageState: 'unread'
    });
    actions.push(receiveTopVoiceMessage(_loggedinKey, voiceMessageDTO, tpn.silent));
  } else if (tpn.type === 'agent_new_message') {
    var _me = app.getIn(['extension', 'chatUserKey']);
    var _data4 = tpn.data;
    var _JSON$parse = JSON.parse(atou(_data4.dto)),
      channelDTO = _JSON$parse.channelDTO,
      _messageDTO3 = _JSON$parse.messageDTO,
      sessionDTO = _JSON$parse.sessionDTO;
    var _senderKey2 = _messageDTO3.from.key;
    var _contact3 = findContactFromChatUserKey(getState, sessionDTO.key, _senderKey2);
    var _chatUserDTO2 = {
      key: _senderKey2,
      contact: _contact3,
      extensionKey: findExtension(getState, function (e) {
        return e.get('chatUserKey') === _senderKey2;
      }).get('key')
    };
    var messageObj = fromJS({
      key: _messageDTO3.key,
      channelKey: channelDTO.key,
      from: _chatUserDTO2,
      message: enchipherMessage(app, _messageDTO3.message),
      read: _me === _senderKey2 || _contact3,
      sent: moment().format(ISO_8601_MS_RESOLUTION),
      source: 'Top'
    });

    //increase badge count for non muted sessions
    if (!tpn.silent) {
      actions.push(channelSessionBadgeCount(channelDTO.key));
    }
    actions.push(receiveTopMessage(sessionDTO.key, messageObj, tpn.silent));
  } else if (tpn.type === 'voicemail_shared') {
    var _data5 = tpn.data;
    var _voiceMessageDTO = fromJS({
      uniqueId: _data5.uniqueId,
      number: _data5.lastCallerId,
      voiceMessageState: 'unread'
    });
    actions.push(receiveTopPbxVoiceMessage(_data5.voicemailEntityKey, _voiceMessageDTO, tpn.silent));
  } else if (tpn.type === 'call_missed') {
    //increase badge count for non silent pushes
    if (!tpn.silent) {
      actions.push(updateMissedCallState());
    }
  } else if (tpn.type === 'call_record_action_added') {
    actions.push(onTopEventCallRecordActionAdded(tpn));
  } else if (tpn.type === 'call_record_action_removed') {
    actions.push(onTopEventCallRecordActionRemoved(tpn));
  } else if (tpn.type === 'chat_added_as_admin') {
    var _tpn$data4 = tpn.data,
      _sessionKey3 = _tpn$data4.sessionKey,
      chatuserKey = _tpn$data4.chatuserKey;
    actions.push(receiveTopAddAdmin(_sessionKey3, chatuserKey));
  } else if (tpn.type === 'chat_remuser') {
    var _tpn$data5 = tpn.data,
      _sessionKey4 = _tpn$data5.sessionKey,
      _chatuserKey = _tpn$data5.chatuserKey;
    actions.push(receiveTopRemoveMemberFromChat(_sessionKey4, _chatuserKey));
  } else if (tpn.type === 'chat_adduser') {
    var _tpn$data6 = tpn.data,
      _sessionKey5 = _tpn$data6.sessionKey,
      _chatuserKey2 = _tpn$data6.chatuserKey,
      _extensionKey = _tpn$data6.extensionKey,
      roomType = _tpn$data6.roomType;
    if (roomType !== roomTypes.external) {
      actions.push(receiveTopAddMemberToChat(_sessionKey5, _chatuserKey2, _extensionKey));
    }
  } else if (tpn.type === 'chat_removed_as_admin') {
    var _tpn$data7 = tpn.data,
      _sessionKey6 = _tpn$data7.sessionKey,
      _chatuserKey3 = _tpn$data7.chatuserKey;
    actions.push(receiveTopRemoveAdmin(_sessionKey6, _chatuserKey3));
  } else if (tpn.type === 'omni_errand') {
    actions.push(onReceivedTopEventPushOfTypeOmniErrand(tpn));
  } else if (tpn.type === 'assigned_omni_errand') {
    actions.push(onReceivedTopEventPushOfTypeAssignedOmniErrand(tpn));
  } else if (tpn.type === 'tickets_badge_count') {
    actions.push(onTopEventPushTypeTicketsBadgeCount(tpn));
  } else if (tpn.type === 'ticket_assignee_set') {
    actions.push(onTopEventPushOfTypeTicketAssigneeSet(tpn));
  } else if (tpn.type === 'ticket_status_set') {
    actions.push(onTopEventPushOfTypeTicketStateSet(tpn));
  } else if (tpn.type === 'ticket_new_internal_note') {
    actions.push(onTopEventPushOfTypeTicketInternalNoteReceived(tpn));
  } else if (tpn.type === 'ticket_new_sms_note') {
    actions.push(onTopEventPushOfTypeTicketSmsReceived(tpn));
  } else if (tpn.type === 'ticket_new_whatsapp_message') {
    actions.push(onTopEventPushOfTypeTicketWhatsAppMessageReceived(tpn));
  } else if (tpn.type === 'ticket_new_email_message') {
    actions.push(onTopEventPushTypeTicketEmailMessageReceived(tpn));
  } else if (tpn.type === 'ticket_new_whatsapp_template_message') {
    actions.push(onTopEventTicketWhatsAppTemplateMessage(tpn));
  } else if (tpn.type === 'ticket_message_status_set') {
    actions.push(onTopEventTicketMessageStatusSet(tpn));
  } else if (tpn.type === 'ticket_unsupported_whatsapp_message') {
    actions.push(onTopEventPushOfTypeTicketWhatsAppUnsupportedMessage(tpn));
  } else if (tpn.type === 'ticket_new_ticket') {
    actions.push(onTopEventPushOfTypeTicketCreatedReceived(tpn));
  } else if (tpn.type === 'ticket_awaiting_activity_set') {
    actions.push(onTopEventTicketAwaitingActivitySet(tpn));
  } else if (tpn.type === 'ticket_subject_set') {
    actions.push(onTopEventTicketSubjectSet(tpn));
  } else if (tpn.type === 'ticket_visibility_set') {
    actions.push(onTopEventTicketVisibilitySet(tpn));
  } else if (tpn.type === 'ticket_transcription_progress') {
    actions.push(onTopEventTicketTranscriptionProgress(tpn));
  } else if (tpn.type === 'ticket_members_change') {
    actions.push(onTopEventPushOfTypeTicketMembersChanged(tpn));
  } else if (tpn.type === 'chat_session_archive') {
    var _data6 = tpn.data;
    var _JSON$parse2 = JSON.parse(atou(_data6.dto)),
      _channelDTO = _JSON$parse2.channelDTO,
      _sessionDTO = _JSON$parse2.sessionDTO;
    actions.push(receiveArchived(_channelDTO.key, _sessionDTO));
  } else if (tpn.type === 'chat_session_unarchive') {
    var _data7 = tpn.data;
    var _JSON$parse3 = JSON.parse(atou(_data7.dto)),
      _channelDTO2 = _JSON$parse3.channelDTO,
      _sessionDTO2 = _JSON$parse3.sessionDTO;
    actions.push(receiveUnarchived(_channelDTO2.key, _sessionDTO2));
  } else if (tpn.type === 'video_incoming_call') {
    actions.push(handleVideo2IncomingCall({
      extensionKey: tpn.data.extensionKey,
      meetingCode: tpn.data.meetingCode
    }));
  } else if (tpn.type === 'video_call_declined') {
    actions.push(handleVideo2CallDeclined({
      extensionKey: tpn.data.extensionKey,
      meetingCode: tpn.data.meetingCode
    }));
  } else if (tpn.type === 'video_call_answered') {
    actions.push(handleVideo2CallAccepted({
      extensionKey: tpn.data.extensionKey
    }));
  } else if (tpn.type === 'video_call_canceled') {
    actions.push(handleVideo2CallCanceled({
      extensionKey: tpn.data.extensionKey,
      meetingCode: tpn.data.meetingCode
    }));
  } else if (tpn.type === 'video_call_handled_on_other_device') {
    actions.push(handleVideo2CallHandledOnOtherDevice({
      extensionKey: tpn.data.extensionKey,
      meetingCode: tpn.data.meetingCode
    }));
  } else if (tpn.type === 'chat_reaction') {
    if (tpn.data.from !== getOwnExtensionKey(getState())) {
      var json = JSON.parse(atou(tpn.data.dto));
      actions.push(updateReactions(json.chatSessionKey, json.messageKey, json.reactionDTO, json === null || json === void 0 ? void 0 : json.threadParentKey));
    }
  } else if (tpn.type === 'call_recording_transcription_progress') {
    actions.push(onTopEventCallRecordingTranscriptionProgress(tpn));
  } else if (tpn.type === 'companion_call_control') {
    actions.push(handleCompanionCallControl(tpn.data));
  } else if (tpn.type === 'companion_designation') {
    actions.push(handleCompanionDesignation(tpn.data));
  } else if (tpn.type === 'companion_location_status') {
    actions.push(handleCompanionLocationStatus(tpn.data));
  }
  return actions;
};
var handlePing = function handlePing() {
  var pong = {
    Response: 'Pong'
  };
  _sendRequest(pong);
};
var handleWelcome = function handleWelcome(msg, username, password, anumber) {
  var auth = {
    Action: 'Login',
    Username: username,
    Password: md5(password + msg.Nonce),
    Anumber: anumber,
    Version: '1.0',
    PushProfiles: 'true',
    PushNotifications: 'true',
    PushQueueAgents: 'true',
    ExternalChannels: 'true',
    SkipExtensionProfiles: 'true',
    PushConferenceMemberCount: 'true',
    OperatorClientType: getClientType(isElectron()),
    IncludeExtensionsWithoutSIPUser: 'true',
    UseNumberInfo: 'true'
  };
  _sendRequest(auth);
};
var TopDebugTool = /*#__PURE__*/_createClass(function TopDebugTool() {
  var _this = this;
  _classCallCheck(this, TopDebugTool);
  _defineProperty(this, "counter", {
    total: 0
  });
  _defineProperty(this, "byteCounter", {
    total: 0
  });
  _defineProperty(this, "startTime", Date.now());
  _defineProperty(this, "enabled", false);
  _defineProperty(this, "updateCounter", function (msg, size) {
    var key = function () {
      if (msg.Action) {
        return 'action-' + msg.Action;
      } else if (msg.Event) {
        return 'event-' + msg.Event;
      } else if (msg.Response) {
        return 'response-' + msg.Response;
      } else {
        console.warn('Unknown message', msg);
        return 'unknown';
      }
    }();
    if (!_this.counter[key]) {
      _this.counter[key] = 0;
    }
    _this.counter[key]++;
    _this.counter['total']++;
    if (!_this.byteCounter[key]) {
      _this.byteCounter[key] = 0;
    }
    _this.byteCounter['total'] += size;
    _this.byteCounter[key] += size;
    if (_this.enabled && _this.counter['total'] % 10 === 0) {
      console.group('Top message count: ' + _this.counter['total'] + ' messages' + ' in ' + _this.byteCounter['total'] + ' bytes' + ' during ' + (Date.now() - _this.startTime) + 'ms');
      var percent = function percent(n, tot) {
        return Math.round(n / tot * 1000) / 10;
      };
      Object.entries(_this.counter).filter(function (e) {
        return e[0] !== 'total';
      }).sort(function (x, y) {
        return y[1] - x[1];
      }).forEach(function (d) {
        var msg = "".concat(d[1], " (").concat(percent(d[1], _this.counter['total']), "%)");
        var byt = "".concat(_this.byteCounter[d[0]], " bytes (").concat(percent(_this.byteCounter[d[0]], _this.byteCounter['total']), "%)");
        console.info(d[0] + ' => ' + msg + ' ' + byt);
      });
      console.groupEnd();
    }
  });
});
if (process.env.NODE_ENV === 'devel') {
  console.info('Activate Top debug using: topDebug.enabled=true');
  window.topDebug = new TopDebugTool();
}
var _topMessageHandler = function topMessageHandler(anumber, username, password) {
  return function (dispatch, getState) {
    return function (msg) {
      var rx = JSON.parse(msg.data);
      if (_topMessageHandler.syncing === false) {
        // addTopLogEntry(msg.data); //Not sending all top events to log at the moment since it is too spammy
      }
      if (window.topDebug) {
        window.topDebug.updateCounter(rx, msg.data.length);
      }
      if (_topMessageHandler.syncing) {
        if (rx.Event === 'SyncStop') {
          syncMessages.forEach(function (message) {
            return messageDispatcher(anumber, username, password)(dispatch, getState)(message);
          });
          syncMessages = [];
        } else {
          syncMessages.push(rx);
          return;
        }
      }
      messageDispatcher(anumber, username, password)(dispatch, getState)(rx);
    };
  };
};
var messageDispatcher = function messageDispatcher(anumber, username, password) {
  return function (dispatch, getState) {
    return function (rx) {
      if (rx.Action === 'Ping') {
        addTopLogEntry('Received: Ping');
        handlePing();
      } else if (rx.Response === 'Pong') {
        addTopLogEntry('Received: Pong');
      } else if (rx.Response === 'Error') {
        handleError(rx);
      } else if (rx.Event === 'Welcome') {
        handleWelcome(rx, username, password, anumber);
      } else if (rx.Event === 'Push') {
        var payload = atou(rx.Payload);
        var json = JSON.parse(payload);
        var actions = pushToActions(getState, json);
        if (actions) {
          actions.map(dispatch);
        } else {
          if (appConfig.environment === 'dev') {
            console.warn('Failed to convert TPN to DTO', payload, actions);
          }
        }
      } else if (rx.Event === 'Extension') {
        dispatch(receiveExtension(rx, true));
      } else if (rx.Event === 'SyncStart') {
        // eslint-disable-line no-empty
        _topMessageHandler.syncing = true;
        addTopLogEntry('Extension sync started');
        queueMemberEventsByQueue.clear();
        dispatch(clearMeetingMemberCountsAction());
        dispatch(receiveSyncStart);
      } else if (rx.Event === 'SyncStop') {
        // eslint-disable-line no-empty
        _topMessageHandler.syncing = false;
        addTopLogEntry('Extension sync stopped');
        dispatch(receiveQueueMembers(queueMemberEventsByQueue));
        dispatch(receiveSyncStop);
        // A hangup sweeps on its own; this covers the fresh start, where the active call list
        // is only complete once the sync has finished and a record left behind by a client
        // that was killed mid-call would otherwise survive.
        dispatch(sweepCompanionMuteState());
      } else if (rx.Event === 'Queue') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'QueueAgent') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'QueueJoin') {
        // eslint-disable-line no-empty
        dispatch(receiveQueueJoinEvent(rx));
      } else if (rx.Event === 'QueueLeave') {
        // eslint-disable-line no-empty
        dispatch(receiveQueueLeaveEvent(rx));
      } else if (rx.Event === 'QueueMember') {
        if (!queueMemberEventsByQueue.has(rx.Queue)) {
          queueMemberEventsByQueue.set(rx.Queue, [rx]);
        } else {
          queueMemberEventsByQueue.get(rx.Queue).push(rx);
        }
      } else if (rx.Event === 'Refer') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'QueueCallInfo') {
        // eslint-disable-line no-empty
        dispatch(receiveQueueCallInfo(rx));
      } else if (rx.Event === 'Profile') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'Redirects') {
        dispatch(receiveActiveProfile(rx));
      } else if (rx.Event === 'Link') {
        dispatch(receiveLink(rx));
      } else if (rx.Event === 'Unlink') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'Rename') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'NewState') {
        // eslint-disable-line no-empty
        dispatch(receiveNewState(rx));
      } else if (rx.Event === 'QueueAgentLoggedIn') {
        // eslint-disable-line no-empty
        dispatch(receiveQueueAgentActivity(rx, true));
      } else if (rx.Event === 'QueueAgentLoggedOut') {
        // eslint-disable-line no-empty
        dispatch(receiveQueueAgentActivity(rx, false));
      } else if (rx.Event === 'QueueAgentAdded') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'OutDial') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'MexIn') {
        // eslint-disable-line no-empty
        dispatch(receiveMexIn(rx));
      } else if (rx.Event === 'MexOut') {
        // eslint-disable-line no-empty
        dispatch(receiveMexOut(rx));
      } else if (rx.Event === 'NewCallerID') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'UpdateCallerID') {
        dispatch(receiveUpdateCallerID(rx));
      } else if (rx.Event === 'Hangup') {
        dispatch(receiveHangup(rx));
      } else if (rx.Event === 'NewChannel') {
        // eslint-disable-line no-empty
        dispatch(receiveNewChannel(rx));
      } else if (rx.Event === 'CallSuccess') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'CallFailure') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'VoicemailStatus') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'Dial') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'AttendedTransferConfirmed') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'AttendedTransferCancelled') {
        dispatch(receiveAttendedTransferCancelled(rx));
      } else if (rx.Event === 'AttendedTransferCompleted') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'ParkedCallGiveUp') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'ParkedCall') {
        // eslint-disable-line no-empty
      } else if (rx.Event === 'NumberInfo') {
        dispatch(receiveNumberInfo(rx));
      } else if (rx.Event === 'GoAway') {
        dispatch(receiveGoAway);
      } else if (rx.Event === 'SetBagVariable') {
        if (rx.Uniqueid) {
          // Uniqueid is named UniqueID in other events
          // Remove when/if fixed in backend
          rx.UniqueID = rx.Uniqueid;
        }
        dispatch(receiveBagVariable(rx));
      } else if (rx.Event === 'CoMonitoredStart') {
        dispatch(receiveCoMonitoredStart(rx));
      } else if (rx.Event === 'CoMonitoredEnd') {
        dispatch(receiveCoMonitoredEnd(rx));
      } else if (rx.Event === 'ExternalChannel') {
        dispatch(receiveExternalChannel(rx));
      } else if (rx.Event === 'MergedIntoConference') {
        dispatch(receiveMergedIntoConference(rx));
      } else if (rx.Response === 'OK') {
        // eslint-disable-line no-empty
        handleOk(rx);
      } else if ('ConferenceMemberCount' === rx.Event) {
        dispatch(recieveMeetingMemberCount(rx));
      } else {
        console.warn('Unhandled message: ', rx);
      }
    };
  };
};

/**
 * Only to be used for tests. Mocks a socket and bounces the request back as a response.
 */
export var mockCreateSocket = function mockCreateSocket() {
  socket = {
    send: function send(request) {
      var actionId = JSON.parse(request).ActionID;
      if (!isNaN(actionId)) {
        var response = JSON.parse(request);
        response.ActionID = actionId.toString();
        if (response.type === 'FAIL') {
          handleError(response);
        } else {
          handleOk(response);
        }
      }
    },
    readyState: WebSocket.OPEN
  };
};

/**
 * Action Redux thunk for creating the Top web socket.
 *
 * Everything belonging to one connection - its ping timers and whether it has finished - lives in
 * this closure rather than in the module, and a socket only touches the module state while it is
 * the current one. A socket given up on keeps firing events until the browser finishes closing it,
 * which on a dead connection can be long after its replacement is up; if it could still clear the
 * shared socket and ping timers, it would leave the replacement unable to send and with nothing
 * watching it, receiving until its connection silently died and then never reconnecting.
 */
var createSocket = function createSocket(endpoint, anumber, username, password, onCloseHandler, retrieveLiveData) {
  return function (dispatch, getState) {
    _topMessageHandler.syncing = false;
    // Events a given-up socket buffered during its sync must not be replayed by the next one
    syncMessages = [];
    pendingRequests.clear();
    if (currentConnection) {
      currentConnection.abandon('Replaced by a new connection');
    }
    return new Promise(function (resolve, reject) {
      var ws = new WebSocket(endpoint);
      var pingInterval = undefined;
      var pingTimeout = 0;
      var connectTimeout = 0;
      var finished = false;
      var clearPingTimeout = function clearPingTimeout() {
        clearTimeout(pingTimeout);
        pingTimeout = 0;
      };
      var isCurrent = function isCurrent() {
        var _currentConnection;
        return ((_currentConnection = currentConnection) === null || _currentConnection === void 0 ? void 0 : _currentConnection.ws) === ws;
      };

      // Runs once per socket, from whichever comes first: the close event, or us deciding
      // the connection is dead. The latter does not wait for the close event, since closing
      // a connection that is already gone can take the browser a long time.
      var finish = function finish(notifyClose) {
        if (finished) {
          return;
        }
        finished = true;
        clearTimeout(connectTimeout);
        clearInterval(pingInterval);
        clearPingTimeout();
        if (!isCurrent()) {
          return;
        }
        currentConnection = null;
        socket = null;
        if (notifyClose && onCloseHandler) {
          onCloseHandler();
        }
      };
      var giveUp = function giveUp(reason, notifyClose) {
        addTopLogEntry("Giving up Top socket to url ".concat(ws.url, ": ").concat(reason));
        // Closed first, so that the close handler already sees the socket as not open.
        try {
          ws.close(CLOSE_EVENT_NORMAL_CODE, reason);
        } finally {
          finish(notifyClose);
        }
      };
      var armPingTimeout = function armPingTimeout(timeoutMs) {
        clearPingTimeout();
        pingTimeout = setTimeout(function () {
          return giveUp("Pong not received in ".concat(timeoutMs, " ms"), true);
        }, timeoutMs);
      };
      var sendPing = function sendPing() {
        if (ws.readyState !== WebSocket.OPEN) {
          return;
        }
        ws.send(JSON.stringify({
          Action: 'Ping'
        }));
        addTopLogEntry('Sent: Ping');
      };
      currentConnection = {
        ws: ws,
        probe: function probe() {
          if (finished || ws.readyState !== WebSocket.OPEN) {
            return;
          }
          sendPing();
          armPingTimeout(PROBE_TIMEOUT_MS);
        },
        // A replaced socket must not reconnect: its replacement is already on the way.
        abandon: function abandon(reason) {
          return giveUp(reason, false);
        }
      };
      socket = ws;
      connectTimeout = setTimeout(function () {
        giveUp("Not open within ".concat(CONNECT_TIMEOUT_MS, " ms"), true);
        reject(new Error('Top socket did not open in time'));
      }, CONNECT_TIMEOUT_MS);
      ws.onopen = function () {
        clearTimeout(connectTimeout);
        if (!isCurrent()) {
          ws.close(CLOSE_EVENT_NORMAL_CODE, 'Replaced by a new connection');
          reject(new Error('Top socket replaced before it opened'));
          return;
        }
        addTopLogEntry("Top socket established to url ".concat(ws.url));
        console.info('Socket established');
        pingInterval = setInterval(function () {
          sendPing();
          if (!pingTimeout) {
            armPingTimeout(PING_TIMEOUT_MS);
          }
        }, PING_INTERVAL_MS);

        // Resolved before the side effects below, so that one of them failing cannot
        // leave the connection unregistered and every later reconnect blocked behind it.
        resolve(ws);
        try {
          if (retrieveLiveData) {
            dispatch(comeBackAPICallbacks);
          }

          // A surface that came up while this companion was quiet has no status at all, and
          // absent reads as "nothing to complain about" - so it would let the user dial and
          // the call would fail with nothing shown. Reporting on every connect is what
          // bounds how long a surface can be wrong about a companion that cannot get a
          // position.
          dispatch(reportKnownCompanionLocationStatus());
        } catch (error) {
          addTopLogEntry('Failed to run Top connect handlers:', error === null || error === void 0 ? void 0 : error.message);
          console.error('Failed to run Top connect handlers', error);
        }
      };
      ws.onerror = function (event) {
        addTopLogEntry('Top socket error message:', event === null || event === void 0 ? void 0 : event.message);
        reject(event);
      };
      ws.onclose = function (closeEvent) {
        addTopLogEntry("Top socket disconnected from url ".concat(ws.url, ": '").concat(JSON.stringify(closeEvent), " because of reason: ").concat(closeEvent === null || closeEvent === void 0 ? void 0 : closeEvent.reason, "'"));
        console.info('Socket disconnected');
        finish(true);
      };
      var handleMessage = _topMessageHandler(anumber, username, password)(dispatch, getState);
      ws.onmessage = function (msg) {
        // Late messages from a socket given up on would be handled twice, or out of
        // order with those of its replacement.
        if (finished || !isCurrent()) {
          return;
        }
        clearPingTimeout();
        handleMessage(msg);
      };
    });
  };
};
export default createSocket;